import DiscordIcon from './DiscordIcon';
export default DiscordIcon;
